import { render, staticRenderFns } from "./toll-free-opt-in-form.vue?vue&type=template&id=dd10509e&scoped=true&"
import script from "./toll-free-opt-in-form.vue?vue&type=script&lang=js&"
export * from "./toll-free-opt-in-form.vue?vue&type=script&lang=js&"
import style0 from "./toll-free-opt-in-form.vue?vue&type=style&index=0&id=dd10509e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd10509e",
  null
  
)

export default component.exports